// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapperList":"MoveTeacher_resultsWrapperList__fe-sp"};